module.exports = __webpack_public_path__ + "img/LBA-Statistik_Umsaetze.52512267.svg";